<template>
  <div class="linkmanTable">

<!--    <div v-if="linkmanListVO.linkmanList.length>0" class="titleRow">-->
    <div  class="titleRow">
      <div style="display:flex;justify-content: space-between;flex:auto;align-items: center;padding-right: 13px;">
        <div style="display: flex;align-items: center">
          <div  class="circleYellow"></div>
          <div  v-if='!isCustomer' class="titleText">{{$t('customer.customerDetail.relatedContact')}}</div>
          <div v-else class="titleText">{{$t('customer.customerDetail.relatedContact1')}}</div>
        </div>
        <div style="">
          <span style="color: #999999" v-if="linkmanListVO.linkmanList.length==0">{{ $t('baseVO.empty') }}</span>
        </div>
      </div>

      <div class="addLinkmanButton" @click="addLinkmanRow" v-if="showEditButtons">
        <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
      </div>
      <div style="width: 27px;" v-else></div>

    </div>
    <div class="contactDiv" v-if="linkmanListVO.linkmanList.length > 0">
      <div v-if="modeType == 1">
        <div class="labelRow">
          <a-row :gutter="10">
            <a-col :span="8">
              <div class="labelText">{{$t('customer.customerDetail.name')}}</div>
            </a-col>
            <a-col :span="8">
              <div class="labelText">{{$t('customer.customerDetail.job')}}</div>
            </a-col>
            <a-col :span="6">
              <div class="labelText">{{$t('customer.customerDetail.abutmentName')}}</div>
            </a-col>
            <a-col :span="2">
            </a-col>
          </a-row>
        </div>
        <div v-for="(linkmanDO,index) in linkmanListVO.linkmanList">
          <div class="contactRow">
            <a-row :gutter="10">
              <a-col :span="8">
                <div class="infoText">{{linkmanDO.name ? linkmanDO.name: '~'}}</div>
              </a-col>
              <a-col :span="8">
                <div class="infoText">{{linkmanDO.job ? linkmanDO.job: '~'}}</div>
              </a-col>
              <a-col :span="6">
                <div class="infoText">{{linkmanDO.createName ? linkmanDO.createName : '~'}}</div>
              </a-col>
              <a-col :span="2">
                <div @click="viewLinkman(linkmanDO)" v-if="showDetail" style="width: 24px;height: 24px;">
                  <pt-icon v-if="$route.path!='/manager/statistics/newMeeting'" type="icon-xiangqingcopy" class="viewIcon" :title="$t('customer.customerDetail.viewLinkman')"></pt-icon>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div v-if="modeType == 3">
        <div class="labelRow">
          <a-row :gutter="4">
            <a-col :span="3">
              <div class="labelText">{{$t('customer.customerDetail.name')}}</div>
            </a-col>
            <a-col :span="7">
              <div class="labelText">{{$t('proprietor.proprietorModal.manageProject')}}</div>
            </a-col>
            <a-col :span="3">
              <div class="labelText">{{$t('customer.customerDetail.job')}}</div>
            </a-col>
            <a-col :span="4">
              <div class="labelText">{{$t('customer.customerDetail.phone')}}</div>
            </a-col>
            <a-col :span="5">
              <div class="labelText">{{$t('customer.customerDetail.email')}}</div>
            </a-col>
            <a-col :span="2"></a-col>
          </a-row>
        </div>
        <a-form :form="linkmanForm">
          <div v-for="(linkmanDO,index) in linkmanListVO.linkmanList">
            <div v-show="editVisibleList.length > 0 && editVisibleList[index].editContact">
              <a-row :gutter="4" style="border-top:1px solid #E7E7E7;">
                <a-col :span="3">
                  <a-form-item>
                    <pt-input style="width: 100%;" v-decorator="[`linkmanList[${index}].editFormData.name`,{rules:[
                  {required:true,message: $t('linkman.modal.nameCNTip'),},
                  {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                  ]}]"></pt-input>
                  </a-form-item>
                </a-col>
                <a-col :span="7">
                  <a-form-item>
                    <pt-select  :dropdownMatchSelectWidth="true"  v-decorator="[`linkmanList[${index}].editFormData.linkmanMansionDOList`,
                    // {initialValue:linkmanDO.editFormData.linkmanMansionDOList},
                    {rules: [

                  ],}]" :maxTagCount="1"  mode="multiple" :placeholder="$t('proprietor.proprietorModal.manageProjectTip')" :allow-clear="false">

                      <a-select-option  v-for="(mansion,index) in mansionList" :key="index" :value="mansion.mansionId">

                        <a-tooltip placement="top">
                          <template #title>
                            <span>{{mansion.mansionName}}</span>
                          </template>
                          {{mansion.mansionName}}
                        </a-tooltip>
                      </a-select-option>
                    </pt-select>
                  </a-form-item>
                </a-col>
                <a-col :span="3">
                  <a-form-item>
                    <pt-input style="width: 100%;" v-decorator="[`linkmanList[${index}].editFormData.job`,{rules: [
                // {required: true,message: $t('linkman.modal.jobTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]"></pt-input>
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                  <a-form-item>
                    <pt-input style="width: 100%;" v-decorator="[`linkmanList[${index}].editFormData.phone`,{rules: [
                // {required: true,message: $t('linkman.modal.mobilePhoneTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]"></pt-input>
                  </a-form-item>
                </a-col>
                <a-col :span="5">
                  <a-form-item style="width: 100%">
                    <pt-input style="width: 100%"
                              v-decorator="[`linkmanList[${index}].editFormData.email`,{rules:[
                   {
                    type: 'email',
                    message:$t('customer.customerModal.emailErrorTip'),
                  },
                  {min: 2, max: 256, message: $t('customer.customerModal.textMaxLength'), trigger: 'blur'},
                  ]}]"></pt-input>
                  </a-form-item>
                </a-col>
                <a-col :span="2">
                  <div class="contactButton" style="margin-top: 12px;float: right;">
                    <div @click="saveContactRow(linkmanDO,index)">
                      <pt-icon type="icon-queding" class="contactIcon"></pt-icon>
                    </div>
                    <div @click="cancelEditContact(linkmanDO,index)" style="margin-left: 10px;">
                      <pt-icon type="icon-shanchubeifen" class="contactIcon"></pt-icon>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div class="contactRow" v-if="editVisibleList.length > 0 && !editVisibleList[index].editContact">
              <a-row :gutter="4">
                <a-col :span="3">
                  <div class="infoText">{{linkmanDO.name ? linkmanDO.name: '~'}}</div>
                </a-col>
                <a-col :span="7">
                  <div v-if="linkmanDO && linkmanDO.linkmanMansionDOList && linkmanDO.linkmanMansionDOList.length > 0">
                    <a-dropdown>
                      <div style="display: flex;flex-direction: row;">
                        <div class="infoText">{{filterMansionName(linkmanDO.linkmanMansionDOList[0].mansionId)}}</div>
                        <div v-if="linkmanDO.linkmanMansionDOList.length > 1" class="numberClass">+{{linkmanDO.linkmanMansionDOList.length-1}}</div>
                        <a-icon type="caret-down" style="color:#999999;" /></div>
                      <a-menu slot="overlay">
                        <a-menu-item v-for="(mansion,Num) in linkmanDO.linkmanMansionDOList" :key="Num">
                          <span>{{filterMansionName(mansion.mansionId)}}</span>
                        </a-menu-item>
                      </a-menu>
                    </a-dropdown>
                  </div>
                  <div v-else>~</div>
                </a-col>
                <a-col :span="3">
                  <div class="infoText">{{linkmanDO.job ? linkmanDO.job: '~'}}</div>
                </a-col>
                <a-col :span="4">
                  <div class="infoText">{{linkmanDO.phone ? linkmanDO.phone: '~'}}</div>
                </a-col>
                <a-col :span="7">
                  <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="infoMailText" style="flex: 1;">{{linkmanDO.email ? linkmanDO.email: '~'}}</div>
                    <div class="contactButton" style="margin-left: 4px;" v-show="showEditButtons">
                      <div @click="editContactRow(linkmanDO,index)">
                        <pt-icon type="icon-bianji1" class="contactIcon"></pt-icon>
                      </div>
                      <div @click="deleteContactRow(linkmanDO,index)" style="margin-left: 10px;" v-if="modeType == 4 || modeType == 5">
                        <pt-icon type="icon-tubiao" class="contactIcon"></pt-icon>
                      </div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-form>
      </div>
      <div v-if="modeType !== 3 && modeType !== 1">
        <div class="labelRow">
          <a-row :gutter="4">
            <a-col :span="4">
              <div class="labelText">{{$t('customer.customerDetail.name')}}</div>
            </a-col>
            <a-col :span="4">
              <div class="labelText">{{$t('customer.customerDetail.job')}}</div>
            </a-col>
            <a-col :span="6">
              <div class="labelText">{{$t('customer.customerDetail.phone')}}</div>
            </a-col>
            <a-col :span="8">
              <div class="labelText">{{$t('customer.customerDetail.email')}}</div>
            </a-col>
            <a-col :span="2"></a-col>
          </a-row>
        </div>
        <a-form :form="linkmanForm">
          <div v-for="(linkmanDO,index) in linkmanListVO.linkmanList">
            <div v-show="editVisibleList.length > 0 && editVisibleList[index].editContact">
              <a-row :gutter="4" style="border-top:1px solid #E7E7E7;">
                <a-col :span="4">
                  <a-form-item>
                    <pt-input style="width: 100%;" v-decorator="[`linkmanList[${index}].editFormData.name`,{rules:[
                  {required:true,message: $t('linkman.modal.nameCNTip'),},
                  {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                  ]}]"></pt-input>
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                  <a-form-item>
                    <pt-input style="width: 100%;" v-decorator="[`linkmanList[${index}].editFormData.job`,{rules: [
                // {required: true,message: $t('linkman.modal.jobTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]"></pt-input>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item>
                    <pt-input style="width: 100%;" v-decorator="[`linkmanList[${index}].editFormData.phone`,{rules: [
                // {required: true,message: $t('linkman.modal.mobilePhoneTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'}
                ],}]"></pt-input>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item style="width: 100%">
                    <pt-input style="width: 100%"
                              v-decorator="[`linkmanList[${index}].editFormData.email`,{rules:[
                   {
                    type: 'email',
                    message:$t('customer.customerModal.emailErrorTip'),
                    rigger: 'blur'
                  },
                  {min: 2, max: 256, message: $t('customer.customerModal.textMaxLength'), trigger: 'blur'},
                  ]}]"></pt-input>
                  </a-form-item>
                </a-col>
                <a-col :span="2">
                  <div class="contactButton" style="margin-top: 12px;float: right;">
                    <div @click="saveContactRow(linkmanDO,index)">
                      <pt-icon type="icon-queding" class="contactIcon"></pt-icon>
                    </div>
                    <div @click="cancelEditContact(linkmanDO,index)" style="margin-left: 10px;">
                      <pt-icon type="icon-shanchubeifen" class="contactIcon"></pt-icon>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div class="contactRow" v-if="editVisibleList.length > 0 && !editVisibleList[index].editContact">
              <a-row>
                <a-col :span="4">
                  <div class="infoText">{{linkmanDO.name ? linkmanDO.name: '~'}}</div>
                </a-col>
                <a-col :span="4">
                  <div class="infoText">{{linkmanDO.job ? linkmanDO.job: '~'}}</div>
                </a-col>
                <a-col :span="6">
                  <div class="infoText">{{linkmanDO.phone ? linkmanDO.phone: '~'}}</div>
                </a-col>
                <a-col :span="10">
                  <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="infoMailText" style="flex: 1;">{{linkmanDO.email ? linkmanDO.email: '~'}}</div>
                    <div class="contactButton" style="margin-left: 4px;" v-show="showEditButtons">
                      <div @click="editContactRow(linkmanDO,index)">
                        <pt-icon type="icon-bianji1" class="contactIcon"></pt-icon>
                      </div>
                      <div @click="deleteContactRow(linkmanDO,index)" style="margin-left: 10px;" v-if="modeType == 4 || modeType == 5">
                        <pt-icon type="icon-tubiao" class="contactIcon"></pt-icon>
                      </div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-form>
      </div>
    </div>
<!--    <div v-else style="background: #fafbfc;margin-bottom: 30px;">-->
<!--      <div style="padding:10px 20px;">-->
<!--        <pt-empty><span slot="description"></span></pt-empty>-->
<!--      </div>-->
<!--    </div>-->
    <pt-modal :title="$t('linkman.newLinkman')" :visible="modalVisible" :loading="addLinkmanLoading" :width="800"
    @ok="saveNewLinkman" @cancel="cancelSave">
      <div slot="content">
        <new-linkman ref="newLinkmanRef" @error="addLinkmanLoading = false" :customer-id="baseInfo.id" :mode-type="modeType" @saveSuccess="cancelSave"></new-linkman>
      </div>
    </pt-modal>
    <pt-modal :title="$t('linkman.detail.title')" :visible="detailVisible" :width="800"  :footer="true"  @cancel="closeDetailModal">
      <div slot="content">
        <linkman-detail :linkman-id="curLinkmanId" :mode-type="1" :justViewDetail="false"></linkman-detail>
      </div>
    </pt-modal>
  </div>
</template>

<script>
  import Api from '@/api/database/linkman'
  import pursuitsLinkmanApi from '@/api/mine/pursuitsLinkman'
  import dealLinkmanApi from '@/api/mine/dealLinkman'
  import NewLinkman from './newLinkman'
  import LinkmanDetail from '../../views/database/linkman/module/linkmanDetail'
  import { mapState } from  'vuex'
  import CustomerRelation from '@/views/database/customer/module/customerRelation'

  export default {
    name: 'linkmanTable',
    components: { LinkmanDetail, NewLinkman,CustomerRelation },
    props:{
      linkmanList:{
        type:Array,
        default:()=>{ return [] }
      },
      baseInfo:{},
      modeType:{
        type:Number,
        default:1, //1新增客户联系人 2新增同行联系人 3新增业主联系人 4追踪关联联系人  5 交易关联联系人,6项目联系人
      },
      showEditButtons:{
        type: Boolean,
        default: true
      },
      showDetail:{
        type:Boolean,
        default:true,
      },
      mansionList:{
        type:Array,
        default:()=>{ return []}
      },
      isCustomer:false
    },
    data(){
      return{
        detailVisible:false,
        curLinkmanId:null,
        modalVisible:false,
        linkmanForm: this.$form.createForm(this, {}),
        linkmanListVO:{
          linkmanList:[]
        },
        editVisibleList:[],
        addLinkmanLoading:false,
      }
    },
    computed:{
      ...mapState({
        accountId: state => state.user.accountId
      }),
    },
    mounted(){
      this.init();
    },
    watch:{
      linkmanList(){
        this.initLinkmanList();
      }
    },
    methods:{
      closeDetailModal(){
        this.detailVisible = false;
      },
      viewLinkman(linkmanDO){
        this.curLinkmanId = linkmanDO.id;
        if(linkmanDO.createrId == this.accountId){
          this.detailVisible = true;
        }else{
          this.$message.warn(this.$t('baseVO.noAuthority'));
        }
      },
      saveNewLinkman(){
        this.addLinkmanLoading = true
        this.$refs.newLinkmanRef.submitData();
      },
      cancelSave(){
        this.addLinkmanLoading = false
        this.modalVisible = false;
      },
      init(){
        this.initLinkmanList();
      },
      filterMansionName(id){
        let curMansionName = '';
        if(id){
          this.mansionList.filter(item =>{
            if(item.mansionId == id){
              curMansionName =  item.mansionName;
            }
          })
        }
        return curMansionName;
      },
      addLinkmanRow(){
        console.log("addLinkmanRow")
        this.$emit("closeEdit")
        if(this.modeType == 1){
          this.modalVisible = true;
        }else{
          this.newLinkmanRow();
        }
      },
      newLinkmanRow(){
        this.editVisibleList.push({editContact:true});
        if(this.modeType !== 3){
          this.linkmanListVO.linkmanList.push(
            {
              name:'',
              job:'',
              phone:'',
              email:'',
              editFormData:{
                name:'',
                job:'',
                phone:'',
                email:''
              }
            }
          )
        }else{
          this.linkmanListVO.linkmanList.push(
            {
              name:'',
              job:'',
              phone:'',
              email:'',
              linkmanMansionDOList:[],
              editFormData:{
                name:'',
                job:'',
                phone:'',
                email:'',
                linkmanMansionDOList:[]
              }
            }
          )
        }
      },
      initLinkmanList(){
        this.editVisibleList = [];
        this.linkmanListVO.linkmanList = [];
        if(this.linkmanList.length > 0){
          // this.linkmanListVO.linkmanList = Object.assign([],this.linkmanList);
          this.linkmanListVO.linkmanList = this.linkmanList.filter((data)=>{return true});
          if(this.modeType !== 3){
            this.linkmanListVO.linkmanList.forEach(item =>{
              item.editFormData = {
                name:item.name,
                job:item.job == '~' ? '':item.job,
                phone:item.phone == '~' ? '':item.phone,
                email:item.email == '~' ? '':item.email,
              }
              this.editVisibleList.push({editContact:false});
            })
          }else{
            let mansionIdList = []
            this.linkmanListVO.linkmanList.forEach(item =>{
              mansionIdList = [];
              if(item.linkmanMansionDOList && item.linkmanMansionDOList.length > 0){
                item.linkmanMansionDOList.forEach(mansion =>{
                  mansionIdList.push(mansion.mansionId)
                });
              }
              item.editFormData = {
                name:item.name,
                job:item.job == '~' ? '':item.job,
                phone:item.phone == '~' ? '':item.phone,
                email:item.email == '~' ? '':item.email,
                linkmanMansionDOList:mansionIdList
              }
              this.editVisibleList.push({editContact:false});
            })
          }
          this.$nextTick(()=>{
            this.linkmanForm.setFieldsValue(this.linkmanListVO);
          })
        }
      },
      saveContactRow(item,index){
        this.linkmanForm.validateFieldsAndScroll((err, values) => {
          if (!err || err.linkmanList[index] == undefined) {
            if(item.id){
              this.updateLinkman(values.linkmanList[index].editFormData,index)
            }else{
              this.insertLinkman(values.linkmanList[index].editFormData,index)
            }
          }else{
            this.$emit("error");
          }
        });

      },
      insertLinkman(data,index){
        let saveData = data;
        let currLinkmanMansionDOList = []
        if(this.modeType == 1 || this.modeType == 2 ){
          saveData.businessId = this.baseInfo.id;
          saveData.type = this.modeType;
        }else if(this.modeType == 3){
          saveData.businessId = this.baseInfo.id;
          saveData.type = this.modeType;
          if(data.linkmanMansionDOList && data.linkmanMansionDOList.length > 0){
            data.linkmanMansionDOList.forEach(item =>{
              currLinkmanMansionDOList.push({mansionId:item});
            })
          }
          saveData.linkmanMansionDOList = currLinkmanMansionDOList;
        }else if(this.modeType == 4){
          saveData.businessId = this.baseInfo.customerId;
          saveData.pursuitsId = this.baseInfo.id;
          saveData.type = 1;
        }else if(this.modeType == 5){
          saveData.businessId = this.baseInfo.customerId;
          saveData.dealId = this.baseInfo.id;
          saveData.type = 1;
        }else if(this.modeType == 6){
          saveData.businessId = this.baseInfo.customerId;
          saveData.projectId = this.baseInfo.id;
          saveData.type = 1;
        }
        saveData.companyName = this.baseInfo.companyName;
        this.$loading.show();
        Api.insert(saveData).then(res => {
          this.$loading.hide();
          if (res.code == 1) {
            let item = res.data;
            if(this.modeType !== 3){
              item.editFormData = {
                name:item.name,
                job:item.job == '~' ? '':item.job,
                phone:item.phone == '~' ? '':item.phone,
                email:item.email == '~' ? '':item.email,
              }
            }else{
              item.editFormData = {
                name:item.name,
                job:item.job == '~' ? '':item.job,
                phone:item.phone == '~' ? '':item.phone,
                email:item.email == '~' ? '':item.email,
                linkmanMansionDOList:currLinkmanMansionDOList,
              }
            }
            this.linkmanListVO.linkmanList[index] = item;
            this.editVisibleList[index].editContact = false;
            this.$message.success(this.$t('linkman.modal.saveSuccessTip'));
          }
        }).catch(()=>{
          this.$loading.hide();
        })
      },
      updateLinkman(data,index){
        let saveData = this.linkmanListVO.linkmanList[index]
        saveData.name = data.name
        saveData.job = data.job
        saveData.email = data.email
        saveData.phone = data.phone
        let currLinkmanMansionDOList = []
        if(this.modeType == 3){
          if(data.linkmanMansionDOList.length > 0){
            data.linkmanMansionDOList.forEach(item =>{
              currLinkmanMansionDOList.push({mansionId:item});
            })
          }
          saveData.linkmanMansionDOList = currLinkmanMansionDOList
        }
        let that = this;
        this.$loading.show();
        Api.update(saveData).then(res=>{
          this.$loading.hide();
          if(res.code == 1){
            if(that.modeType == 3){
              that.linkmanListVO.linkmanList[index].linkmanMansionDOList = [];
              currLinkmanMansionDOList.forEach(item => {
                that.linkmanListVO.linkmanList[index].linkmanMansionDOList.push(
                  {mansionId:item.mansionId}
                )
              })
            }
            that.editVisibleList[index].editContact = false;
            that.$message.success(res.message)
            that.$emit('editLinkman')
          }
        }).catch(()=>{
          this.$loading.hide();
        })
      },
      cancelEditContact(item,index){
        this.$emit('closeEdit')
        if(item.id){
          item.editFormData = {
            name:item.name,
            job:item.job == '~' ? '':item.job,
            phone:item.phone == '~' ? '':item.phone,
            email:item.email == '~' ? '':item.email,
          }
          this.editVisibleList[index].editContact = false;
        }else{
          let keys = this.linkmanForm.getFieldValue('linkmanList');
          this.linkmanForm.setFieldsValue({
            linkmanList: keys.filter((item,i) => index !== i)
          })
          this.linkmanListVO.linkmanList.splice(index, 1);
          this.editVisibleList.splice(index,1);
        }
      },
      editContactRow(item,index){
        this.$emit('closeEdit')
        this.editVisibleList[index].editContact = true;
      },
      deleteContactRow(item,index){
        let _this = this;
        this.$emit('closeEdit')
        this.$ptConfirm({
          title: _this.$t('linkman.delete.title'),
          content: _this.$t('linkman.delete.content'),
          okType: 'primary',
          onOk() {
            _this.execDelete(item,index)
          },
          onCancel() {

          },
        });
      },
      execDelete(item,index){
        if(this.modeType == 1 || this.modeType == 2 || this.modeType == 3){
          Api.deleteObj(item.id).then(res=>{
            if(res.code == 1){
              //删除一个联系人
              this.$message.success(res.message)
              // this.linkmanList.splice(index, 1);
              this.linkmanListVO.linkmanList.splice(index,1);
              this.editVisibleList.splice(index,1);
            }
          })
        }else if(this.modeType == 4){
          let pursuitsId = this.baseInfo.id;
          pursuitsLinkmanApi.deleteLinkman(pursuitsId,item.id).then(res=>{
            if(res.code == 1){
              this.$message.success(res.message)
              // this.linkmanList.splice(index, 1);
              let keys = this.linkmanForm.getFieldValue('linkmanList');
              this.linkmanForm.setFieldsValue({
                linkmanList: keys.filter((item,i) => index !== i)
              })
              this.linkmanListVO.linkmanList.splice(index,1);
              this.editVisibleList.splice(index,1);
            }
          })
        }else if(this.modeType == 5){
          let dealId = this.baseInfo.id;
          dealLinkmanApi.deleteLinkman(dealId,item.id).then(res=>{
            if(res.code == 1){
              this.$message.success(res.message)
              // this.linkmanList.splice(index, 1);
              let keys = this.linkmanForm.getFieldValue('linkmanList');
              this.linkmanForm.setFieldsValue({
                linkmanList: keys.filter((item,i) => index !== i)
              })
              this.linkmanListVO.linkmanList.splice(index,1);
              this.editVisibleList.splice(index,1);
            }
          })
        }
      },
    },

  }
</script>

<style scoped lang="less">
  .linkmanTable{
    .numberClass{
      cursor: pointer;
      background: #ADADAD;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      margin-left: 4px;
      font-size: 12px;
      color: #FFFFFF;
    }
    .titleRow{
      background: #FAFBFC;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 5px;
      .circleYellow{
        width: 12px;
        height: 12px;
        background: #FABE00;
        border-radius: 50%;
        margin: 0 10px;
      }
      .titleText{
        font-size: 14px;
        color: #333333;
        font-weight: bold;
      }
      .addLinkmanButton{
        width: 16px;
        height: 16px;
        border: 1px solid #8E8E8E;
        border-radius: 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: auto;
        margin-right: 12px;
        .addIcon{
          font-size: 12px;
          color: #8E8E8E;
        }
      }
      .addLinkmanButton:hover{
        border: 1px solid #FABE00;
        .addIcon{
          color: #FABE00;
        }
      }
    }
    .contactDiv{
      padding: 0 16px;
      background: #FAFBFC;
      margin-bottom: 30px;
      .labelText{
        font-size: 12px;
        color: #999999;
      }
      .infoText{
        font-size: 12px;
        color: #333333;
        max-width:100px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .infoMailText{
        font-size: 12px;
        color: #333333;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .labelRow{
        padding: 10px 0 6px 0;
      }
      .contactIcon{
        font-size: 14px;
      }
      .contactButton{
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .contactRow{
        border-top: 1px solid #E7E7E7;
        padding: 10px 0 6px 0;
      }
    }
  }
</style>
<style>
  .linkmanTable .ant-select-selection__choice__content{
    max-width: 32px !important;
  }
</style>